import { useQuery } from '@tanstack/react-query';
import { getWithdrawalsPreferences } from 'commons/services/withdrawsConfigService/WithdrawsConfigService';
import { WithdrawalsPreferencesResponse } from 'commons/types/WithdrawsConfigType';

export const withdrawalsPreferencesKey = ['withdrawals-preferences'] as const;

export const useGetWithdrawalsPreferences = () => {
  const { data, isLoading, isError, isSuccess } =
    useQuery<WithdrawalsPreferencesResponse>(
      withdrawalsPreferencesKey,
      getWithdrawalsPreferences,
    );

  const isWithdrawalPreferencesEnabled = isSuccess && data?.enabled;
  const isAutomatedWithdrawEnabled =
    isWithdrawalPreferencesEnabled && data?.interval !== 'manual';

  return {
    data,
    isAutomatedWithdrawEnabled,
    isError,
    isLoading,
    isWithdrawalPreferencesEnabled,
  };
};
